import React from 'react'
import Select from 'react-select'
import styled from 'styled-components'

const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    boxShadow: state.isFocused ? '0 0 0 3px rgba(201, 77, 170, 0.12)' : 'none',
    border: state.isFocused
      ? '1px solid rgba(201, 77, 170, 0.55)'
      : '1px solid rgba(23, 23, 23, 0.1)',
    borderRadius: 14,
    height: 48,
    width: '100%',
    minHeight: 48,
    marginTop: 0,
    cursor: 'pointer',
    background: '#fff',
    fontFamily: 'Montserrat, sans-serif',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
    '&:hover': {
      borderColor: 'rgba(201, 77, 170, 0.4)',
    },
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    background: state.isSelected
      ? 'linear-gradient(144.01deg, rgba(255, 201, 81, 0.95) 0%, rgba(206, 86, 176, 0.95) 100%)'
      : state.isFocused
        ? 'rgba(201, 77, 170, 0.1)'
        : 'white',
    color: state.isSelected ? '#fff' : state.isFocused ? '#c94daa' : '#171717',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: state.isSelected ? 700 : 500,
    fontSize: 13,
    borderRadius: 8,
    margin: '2px 6px',
    width: 'calc(100% - 12px)',
    cursor: 'pointer',
    '&:active': {
      background:
        'linear-gradient(144.01deg, rgba(255, 201, 81, 0.95) 0%, rgba(206, 86, 176, 0.95) 100%)',
      color: '#fff',
    },
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: 14,
    border: '1px solid rgba(23, 23, 23, 0.06)',
    boxShadow: '0 16px 40px rgba(0, 0, 0, 0.14)',
    overflow: 'hidden',
    zIndex: 20,
  }),
  menuList: (provided: any) => ({
    ...provided,
    padding: '6px 0',
    maxHeight: 220,
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: '#171717',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: 14,
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: 'rgba(23, 23, 23, 0.4)',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 13,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: '#c94daa',
    '&:hover': { color: '#c94daa' },
  }),
}

const hoursOptions = Array.from({ length: 24 }, (_, i) => ({
  value: i + 1,
  label: `${i + 1}`,
}))

interface HourPickerProps {
  value?: { value: number; label: string }
  onChange: (hour: number) => void
}

const HourPicker: React.FC<HourPickerProps> = ({ value, onChange }) => {
  return (
    <Container>
      <Select
        options={hoursOptions}
        value={value}
        onChange={(option: any) => onChange(option.value)}
        placeholder="Select duration (hours)"
        styles={customStyles}
      />
    </Container>
  )
}

export default HourPicker

const Container = styled.div`
  width: 100%;
`
